import React, { useContext, useEffect } from 'react';
import { OverlayProvider } from '@legacy-vfuk/core-overlay-controller';
import Button from '@legacy-vfuk/core-button';
import { Modal } from '@legacy-vfuk/core-modal';

import { SaveArticleModalProps } from './types/SaveArticleModal.types';
import {
  ButtonWrapper,
  FooterWrapper,
  ModalContentContainer,
  CloseIconWrapper,
} from './styles/SaveArticleModal.styles';
import fireButtonAndLinkClicksEvent from '../../helpers/fireButtonAndLinkClicksEvent';
import { extractArticleSlug } from '../../helpers/navigationHelpers';
import { Icon } from '@legacy-vfuk/core-icon';
import { DirectionContext } from '../../contexts/DirectionContext';

const SaveArticleModal: React.FC<SaveArticleModalProps> = ({
  header,
  bodyText,
  buttonText,
  buttonUrl,
  footerText,
  footerLinkText,
  footerLinkUrl,
  articleSlug,
  onArticle,
  isOpen,
  onClose,
}) => {
  const direction = useContext(DirectionContext);

  const extractedArticleSlug = articleSlug && extractArticleSlug(articleSlug);

  const createLinkWithArticleSlug = (link: string) => {
    if (link.includes('?')) {
      return onArticle
        ? link + '&from=article&save_article=' + extractedArticleSlug
        : link + '&save_article=' + extractedArticleSlug;
    } else {
      return onArticle
        ? link + '?from=article&save_article=' + extractedArticleSlug
        : link + '?save_article=' + extractedArticleSlug;
    }
  };

  const onSignUpClickHandler = () => {
    fireButtonAndLinkClicksEvent({
      event_label: 'Sign up and save article: ' + extractedArticleSlug,
      event_action: 'button click',
    });
  };

  const onSignInClickHandler = () => {
    fireButtonAndLinkClicksEvent({
      event_label: 'Sign in and save article: ' + extractedArticleSlug,
      event_action: 'link click',
    });
  };

  return (
    <OverlayProvider>
      <Modal
        id="save-modal"
        srName="save-article-modal"
        isOpen={isOpen}
        size={3}
        animate
        isClosable={false}
        onCloseCb={() => {
          onClose();
        }}
      >
        <ModalContentContainer>
          <h3>{header}</h3>
          <p>{bodyText}</p>
          <ButtonWrapper>
            <Button
              text={buttonText}
              appearance="primary"
              href={createLinkWithArticleSlug(buttonUrl)}
              htmlAttributes={{ target: '_blank' }}
              onClick={onSignUpClickHandler}
            />
          </ButtonWrapper>
          <CloseIconWrapper onClick={onClose} direction={direction}>
            <Icon name="close" size={5} appearance={'primary'} />
          </CloseIconWrapper>
          <FooterWrapper>
            <span>
              {footerText}&nbsp;
              <a
                href={createLinkWithArticleSlug(footerLinkUrl)}
                target="_blank"
                onClick={onSignInClickHandler}
              >
                {footerLinkText}
              </a>
            </span>
          </FooterWrapper>
        </ModalContentContainer>
      </Modal>
    </OverlayProvider>
  );
};

export default SaveArticleModal;
